"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimestamp = exports.TimestampStruct = exports.TimestampMock = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var TimestampMock = /** @class */ (function () {
    function TimestampMock(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
    }
    TimestampMock.prototype.isEqual = function (other) {
        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
    };
    TimestampMock.prototype.toDate = function () {
        return new Date(this.toMillis());
    };
    TimestampMock.prototype.toMillis = function () {
        return this.seconds * 1000 + this.nanoseconds / 1e6;
    };
    return TimestampMock;
}());
exports.TimestampMock = TimestampMock;
exports.TimestampStruct = (0, superstruct_1.type)({
    nanoseconds: (0, superstruct_1.number)(),
    seconds: (0, superstruct_1.number)(),
    isEqual: (0, superstruct_1.func)(),
    toDate: (0, superstruct_1.func)(),
    toMillis: (0, superstruct_1.func)(),
});
function isTimestamp(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.TimestampStruct, "Timestamp");
}
exports.isTimestamp = isTimestamp;
